<script>
import resources from './resources'

export default {
  name: 'input-tag',
  mixins: [resources]
}
</script>

<template lang="pug">
    div
      .vue-input-tag-wrapper(
        @click='focusNewTag()',
        :class="{'read-only': readOnly, 'vue-input-tag-wrapper--active': isInputActive}")
        span.select-list(v-for='(tag, index) in innerTags', :key='index')
          | {{ tag }}
          span(v-if='!readOnly', @click.prevent.stop='remove(index)')
           .exclude 

        input.new-tag(
          v-if='!readOnly && !isLimit',
          ref='inputtag',
          :placeholder='placeholder',
          type='text',
          v-model='newTag',
          v-on:keydown.delete.stop='removeLastTag',
          v-on:keydown='addNew',
          v-on:blur='handleInputBlur',
          v-on:focus='handleInputFocus')

      button.btn.save.pull-right(@click.prevent="saveTags()")
        span.icon &#xE911;
        |  Salvar Palavras Chave
        .border-botton


</template>

<style>

.select-list {
  display: inline-block;
  padding: 5px 45px 5px 15px;
  margin: 1px;
  border-radius: 15px;
  border: 1px solid #ed193b;
  background-color: #ed193b;
  color: #fff;
  position: relative;
}

.select-list:hover,
.select-list.hover {
  -webkit-box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.25);
  box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.25);
}

.select-list .exclude {
  font-family: 'agenda-font-icons';
  position: absolute;
  top: 0px;
  right: 15px;
  cursor: pointer;
  padding: 5px;
}

.select-list .exclude:hover {
  -webkit-transform: rotate(180deg);
  -ms-transform: rotate(180deg);
  transform: rotate(180deg);
}

.select-list:hover .exclude,
.select-list.hover .exclude {
  color: #fff;
}

.btn.save {
    border: 1px solid #00ce18;
    background: #fff;
    border-radius: 50px;
    color: #00ce18;
    margin-right: 10px;
}
.vue-input-tag-wrapper {
  background-color: #fff;
  border: 1px solid #ccc;
  overflow: hidden;
  padding-left: 4px;
  padding-top: 0px;
  cursor: text;
  text-align: left;
  -webkit-appearance: textfield;
  display: flex;
  flex-wrap: wrap;
  border: 1px solid #ccc;
  border-radius: 4px;
}

.vue-input-tag-wrapper .input-tag {
  background-color: red;
  border-radius: 20px;
  border: 1px solid #fff;
  display: inline-block;
  margin-bottom: 4px;
  margin-right: 4px;
  padding: 5px;
  color: #fff;
  font-weight: bold;
}

.vue-input-tag-wrapper .input-tag .remove {
  font-family: 'agenda-font-icons';
  cursor: pointer;
  font-weight: bold;
  color: #fff;
}

.vue-input-tag-wrapper .input-tag .remove:hover {
  -webkit-transform: rotate(180deg);
  -ms-transform: rotate(180deg);
  transform: rotate(180deg);
}

.vue-input-tag-wrapper .input-tag .remove::before {
  font-family: 'agenda-font-icons';
}

.vue-input-tag-wrapper .new-tag {
  background: transparent;
  border: 0;
  color: #777;
  font-size: 13px;
  font-weight: 400;
  margin-bottom: 6px;
  margin-top: 1px;
  outline: none;
  padding: 4px;
  padding-left: 5px;
  flex-grow: 1;
}

.vue-input-tag-wrapper.read-only {
  cursor: default;
}
</style>



// WEBPACK FOOTER //
// src/app/professional/company/companies/components/tags/tag.vue